import React, { useContext, useMemo } from 'react';
import './ProductoCard.css';
import { PromocionesContext } from '../../../contexts/PromocionesContext';

/**
 * Componente para mostrar un producto con soporte mejorado para promociones
 * @param {Object} producto - Datos del producto a mostrar
 * @param {Function} onAgregarProducto - Función para agregar el producto al pedido
 * @param {Function} onVerDetalles - Función para ver los detalles del producto
 */
const ProductoCardMejorado = ({ producto, onAgregarProducto, onVerDetalles }) => {
  // Obtener información de promociones del contexto
  const { verificarPromociones } = useContext(PromocionesContext);

  // Verificar promociones para este producto específico
  const infoPromocion = verificarPromociones(producto);

  // Determinar si tiene promoción y qué tipo
  const tienePromocion = infoPromocion.enPromocion;

  // Obtener detalles de las promociones disponibles
  const datosPromocion = useMemo(() => {
    if (!tienePromocion || !infoPromocion.promociones || infoPromocion.promociones.length === 0) {
      return { nombre: '', tipoPromocion: '', descripcion: '' };
    }

    // Obtener la primera promoción (normalmente sería la más ventajosa)
    const promo = infoPromocion.promociones[0];
    let tipoTexto = '';
    let descripcion = '';
    let productos = []

    // Formatear texto según el tipo de promoción
    switch (promo.tipo) {
      case '1':
        tipoTexto = '';
        descripcion = `${promo.porcentajeDescuento}% off`;
        break;
      case '2':
        tipoTexto = '';
        descripcion = `${promo.nombre}`;
        break;
      case '3':
        tipoTexto = '';
        descripcion = `${promo.nombre}`;
        //  productos = promo.produc
        break;
      default:
        tipoTexto = '📢 PROMO';
    }

    return {
      nombre: promo.nombre,
      tipoPromocion: tipoTexto,
      descripcion
    };
  }, [infoPromocion, tienePromocion]);

  // Texto a mostrar en el badge de promoción
  const textoPromocion = datosPromocion.tipoPromocion
    ? `${datosPromocion.tipoPromocion} - ${datosPromocion.descripcion}`
    : datosPromocion.nombre;

  return (
    <div
      className={`producto-card ${tienePromocion ? 'con-promocion' : ''}`}
      onClick={() => onAgregarProducto(producto)}
    >
      {/* Badge de promoción mejorado */}
      {tienePromocion && (
        <div className="promocion-badge-destacado" title={datosPromocion.nombre}>
          {textoPromocion}
        </div>
      )}

      <div className="producto-info">
        <h3 className="producto-nombre">{producto.nombre} </h3>
        <div className="producto-precio">
          ${parseFloat(producto.precio).toFixed(2)}
        </div>
      </div>
      <div className='ver-detalles-btn2'>.</div>

      <button
        className="ver-detalles-btn"
        onClick={(e) => onVerDetalles(e, producto)}
      >
        <i className="info-icon">i</i>
      </button>
    </div>
  );
};

export default ProductoCardMejorado;